import {DotNetObjectReference} from "@App/BlazorTypes";
import {DragDropManager} from "@App/DragDropManager";
import {ProximityHandlerResult} from "@App/ProximityHandler";

const dragManager = new DragDropManager();

export type DraggableConfiguration = {
    proximityCheckDistance: number;
    snapDistance: number;
    proximityCallback: (result:ProximityHandlerResult) => void
};
export async function dragDropHandler_registerDraggable(element: HTMLElement, configuration: DraggableConfiguration, dotNetHelper: DotNetObjectReference): Promise<void> {
    
    configuration.proximityCallback = (proximityResult: ProximityHandlerResult) => {
        let body = proximityResult.CurrentlyClosest != null ? {
            targetDomId: proximityResult.CurrentlyClosest.getAttribute("attr-targetdomid"),
            position: proximityResult.CurrentlyClosest.getAttribute("attr-position"),
            containerId: proximityResult.CurrentlyClosest.getAttribute("attr-containerid"),
        } : null;
        dotNetHelper.invokeMethod("GetProximityCandidate", body);
    };
    
    dragManager.registerElement(element,configuration);
}

export async function dragDropHandler_disposeDraggable(element: HTMLElement): Promise<void> {
    dragManager.disposeElement(element);
}

export async function dragDropHandler_firstInitialization(): Promise<void> {
    document.addEventListener("dragenter", (e) => {
        if(e.dataTransfer != null) {
            e.dataTransfer.dropEffect = "move";
            e.preventDefault();
        }
    });
}
